import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import ShopItem from './ShopItem';
import CheckboxButton from '../../../../common/CheckboxButton';

const ShopTable = ({ shops, allSelected, setAllSelected, formValues }) => (
  <div className="c-wrapper">
    <div className="u-max-width-1000 u-margin-auto u-mv-">
      <div className="c-table-card c-table-new u-table-layout-fixed c-no-hover ">
        <div className="c-table-card__row c-table-card__row--transparent">
          <div className="c-table-card__cell u-1/10">
            <CheckboxButton
              onClick={() => setAllSelected(!allSelected)}
              label="Select All"
              checkedLabel="Deselect All"
              checked={allSelected}
              display-if={shops.length > 1}
            />
          </div>
          <div className="c-table-card__cell u-5/10" />
          <div className="c-table-card__cell u-4/10" />
        </div>
      </div>
      {shops.map(shop => (
        <ShopItem
          shop={shop} key={shop.id} disabled={shops.length === 1}
          selected={get(formValues, ['shops', shop.id, 'enabled'], false)}
        />
      ))}
    </div>
  </div>
);

ShopTable.propTypes = {
  shops: PropTypes.array.isRequired, //eslint-disable-line
  allSelected: PropTypes.bool.isRequired,
  setAllSelected: PropTypes.func.isRequired,
  formValues: PropTypes.shape({ shops: PropTypes.object }).isRequired,
};

export default ShopTable;
